import axios from 'axios';

const TenantService = {
  async getTenantInfo() {
    const tenantId = this.getTenantId();
    try {
      const response = await this.tenantGet(`tenant/info/${tenantId}`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch tenant info:', error);
      return { logo: null, name: 'SchoolPeak' };
    }
  },
  
  getTenantId() {
    if (window.location.hostname === 'localhost') {
      return 'tenant1';
    }
    
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    if (parts.length >= 3 && parts[parts.length - 2] === 'schoolpeak') {
      return parts[0]; 
    }
    
    return 'tenant1';
  },
  
  isLocalDevelopment() {
    return window.location.hostname === 'localhost';
  },
  
  tenantApiCall(endpoint, method = 'get', data = null, options = {}) {
    const tenantId = this.getTenantId();
    const baseApiUrl = process.env.VUE_APP_API_BASE_URL;
    const isProduction = baseApiUrl?.includes('api.schoolpeak.org');
    const isLocal = this.isLocalDevelopment();
    
    // Remove leading slash from endpoint if it exists
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    
    let url;
    
    if (isProduction) {
      url = `https://${tenantId}.schoolpeak.org/api/${cleanEndpoint}`;
    } else {
      // For local development
      if (baseApiUrl) {
        // Remove trailing slash from baseApiUrl if it exists
        const cleanBaseApiUrl = baseApiUrl.endsWith('/') ? baseApiUrl.slice(0, -1) : baseApiUrl;
        
        // Check if baseApiUrl already includes /api
        if (cleanBaseApiUrl.endsWith('/api')) {
          url = `${cleanBaseApiUrl}/${cleanEndpoint}`;
        } else {
          url = `${cleanBaseApiUrl}/api/${cleanEndpoint}`;
        }
      } else {
        // If no baseApiUrl is provided, construct from window.location
        url = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/api/${cleanEndpoint}`;
      }
    }

    // Only force HTTPS in production, not in local development
    if (!isLocal && url.startsWith('http:')) {
      url = url.replace('http:', 'https:');
    }

    console.log('Making API call to:', url);
    
    options.headers = options.headers || {};
    
    switch (method.toLowerCase()) {
      case 'post':
        return axios.post(url, data, options);
      case 'put':
        return axios.put(url, data, options);
      case 'delete':
        return axios.delete(url, options);
      case 'patch':
        return axios.patch(url, data, options);
      case 'get':
      default:
        return axios.get(url, options);
    }
  },
  
  tenantGet(endpoint, options = {}) {
    return this.tenantApiCall(endpoint, 'get', null, options);
  },
  
  tenantPost(endpoint, data, options = {}) {
    return this.tenantApiCall(endpoint, 'post', data, options);
  },
  
  tenantPut(endpoint, data, options = {}) {
    return this.tenantApiCall(endpoint, 'put', data, options);
  },
  
  tenantDelete(endpoint, options = {}) {
    return this.tenantApiCall(endpoint, 'delete', null, options);
  },
  
  ensureHttpsUrl(url) {
    if (!url) return url;
    
    const isLocal = this.isLocalDevelopment();
    
    // For local development, don't force HTTPS
    if (isLocal) {
      return url;
    }
    
    if (url.startsWith('//')) {
      return `https:${url}`;
    }
    
    if (url.startsWith('http:')) {
      return url.replace('http:', 'https:');
    }
    
    if (url.startsWith('/')) {
      const tenantId = this.getTenantId();
      return `https://${tenantId}.schoolpeak.org${url}`;
    }
    
    if (!url.startsWith('http')) {
      const tenantId = this.getTenantId();
      return `https://${tenantId}.schoolpeak.org/${url}`;
    }
    
    return url;
  }
};

export default TenantService;